import { FormRow } from 'framework/ui/layout';
import { useEffect } from 'react';
import { EnumDropdown, useInputHelper } from 'framework/form';
import {
  APPROVAL_TYPE,
  CUSTOMER_REPORT_FREQUENCY,
  REPORT_FREQUENCY_OPTIONS,
  SYSTEM_REPORT_OPTIONS,
} from 'domain/shared/newProject';
import { Stack } from '@mui/material';
import ApprovalTypeSelector from '../../shared/mainProjectSection/ApprovalTypeSelector';

const CustomerReportForm = ({ source, initialValue }: any) => {
  const { getValue, getRawOnChangeCallback } = useInputHelper({ source });
  const rawOnChangeCallback = getRawOnChangeCallback();

  useEffect(() => {
    if (!getValue()) {
      rawOnChangeCallback?.({
        [`${source}`]: initialValue || {
          isSystemReportUsed: true,
          reportFrequency: CUSTOMER_REPORT_FREQUENCY.WEEKLY,
          approvalType: APPROVAL_TYPE.MANUAL_APPROVAL,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formData = getValue();
  const isCustomSystem = formData?.isSystemReportUsed === false || formData?.isSystemReportUsed === 'false';

  return (
    <Stack>
      <FormRow colMd={3} colXl={3}>
        <EnumDropdown
          source={`${source}.isSystemReportUsed`}
          label="Customer Report system"
          options={SYSTEM_REPORT_OPTIONS}
        />
        <EnumDropdown
          source={`${source}.reportFrequency`}
          label="Customer report frequency"
          options={REPORT_FREQUENCY_OPTIONS}
        />
        {!isCustomSystem && <ApprovalTypeSelector source={`${source}.approvalType`} />}
      </FormRow>
    </Stack>
  );
};

export default CustomerReportForm;
